<ul>
    <li *ngFor="let team of teamList; let i=index;" (click)="openTeam($event, team.id)">
        <div class="list-item-block team-item glass-blurred-background drop-shadow">
            <img class="pic space-below svg-white list-avatar" src="./assets/imgs/avatar.svg">
            <div class="name center-content-vertical">{{ team.name }}</div>

            <div class="product center-content-vertical">
                Manager: {{ team.name |titlecase}} {{ team.lastname |titlecase}}
            </div>
        </div>

        <!-- livello 2 -->
        <app-team-node [teamList]="team?.nextNode"></app-team-node>
        <!--// livello 2 -->

    </li>
</ul>
